import React, { Component } from "react";

export class CustomHeader extends Component {
  render() {
    const { header } = this.props;
    return (
      <div style={{ position: "absolute", marginLeft: "10px", marginRight: "10px",top: "0px" }}>
        <img
          style={{
            width: "95%",
            height: "100px",
            display: "block",
            paddingTop: "5px",
            paddingBottom: "15px"
          }}
          src={header ? header : ""}
          alt={"logo"}
        />
      </div>
    );
  }
}
